<template>
  <div class="channels">
    <div class="container">
      <div class="columns is-centered">
        <div class="column is-12 is-three-quarters-tablet is-two-thirds-desktop has-text-left">
          <article
            class="message is-info"
            v-for="(entry, key) in allentries"
            :key="key"
          >
            <div class="message-header">
              <a
                :href="decodeURIComponent(entry.entryUrl)"
                target="_blank"
                style="font-size: small;"
              >
                <span class="is-size-4">{{ entry.entryTitle }}</span>
              </a>
            </div>
            <div class="message-body">
              <div class="columns">
                <div class="column is-narrow">
                  <figure
                    class="image is-64x64"
                    style="background-color: #ddd;"
                  >
                    <div v-if="entry.entryImg">
                      <a
                        :href="entry.entryUrl"
                        target="_blank"
                        style="font-size: small;"
                      >
                        <img :src="entry.entryImg">
                      </a>
                    </div>
                    <div v-else>
                      <img :src="noimage_src">
                    </div>
                  </figure>
                </div>
                <div class="column">
                  <div class="is-size-6">{{ entry.entryDesc }}</div>
                  <div class="has-text-right" style='margin-bottom: 6px; '>
                    <span v-if="entry.entryPodcasterTwitterUrl">
                      <a :href="entry.entryPodcasterTwitterUrl">
                        <span class="tag is-info">
                          <i class="fab fa-twitter"></i>&nbsp;配信者Twitter
                        </span>
                      </a>
                    </span>&nbsp;
                    <span v-if="entry.entryChannelTwitterUrl">
                      <a :href="entry.entryChannelTwitterUrl">
                        <span class="tag is-info">
                          <i class="fab fa-twitter"></i>&nbsp;番組公式Twitter
                        </span>
                      </a>
                    </span>
                  </div>
                  <div v-if="entry.entrySpecialEpisodeUrl">
                    <div class="tags has-addons has-text-left is-marginless">
                      <span class="tag is-warning">Special Episode!</span>
                      <span class="tag is-light">春のポッドキャストまつり向けエピソード</span>
                    </div>
                    <div class="is-size-6">
                      <a :href="entry.entrySpecialEpisodeUrl">
                        <div>{{ entry.entrySpecialEpisodeDesc }}</div>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <!--
            <button
              class='button is-pulled-right'
              type="submit"
              v-on:click="deleteEntry(key)"
            ><i class="fas fa-trash-alt"></i></button>
              -->
            </div>
          </article>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from "@/components/FirebaseInit";

export default {
  name: "channels",
  components: {},
  data() {
    return {
      noimage_src: require("@/assets/noimage.jpg"),
      database: null,
      entriesRef: null,
      entries: []
    };
  },
  created: function() {
    this.entriesRef = firebase.collection("entries");
    this.entriesRef.onSnapshot(() => {
      this.getAllEntries();
    });
  },
  computed: {
    allentries: function() {
      return this.entries;
    }
  },
  methods: {
    getAllEntries: function() {
      let newEntries = [];
      this.entriesRef
        .get()
        .then(querySnapshot => {
          querySnapshot.forEach(doc => {
            newEntries.push(doc.data());
          });
          // ランダムソートして返却する
          // Array#sort実装のshuffleは偏る - Qiita
          // https://qiita.com/minodisk/items/94b6287468d0e165f6d9
          for (let i = newEntries.length - 1; i > 0; i--) {
            let r = Math.floor(Math.random() * (i + 1));
            let tmp = newEntries[i];
            newEntries[i] = newEntries[r];
            newEntries[r] = tmp;
          }
          this.entries = newEntries;
        })
        .catch(error => {
          this.showDbError(error);
        });
    }
  }
};
</script>
